<template>
  <v-container>
    <v-card
        max-width="800"
        class="mx-auto"
    >
      <v-toolbar
          dark
      >
        <v-app-bar-nav-icon></v-app-bar-nav-icon>

        <v-toolbar-title>Ganhadores ({{ this.$store.state.winners.length }})</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="exportCSV">
          <v-icon>mdi-download-outline</v-icon>
        </v-btn>
        <v-btn icon @click="clearAllWinners">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <v-alert v-if="this.$store.state.winners.length === 0"
               type="warning"
               outlined
      >
        Ainda não existem ganhadores na lista
      </v-alert>
      <v-subheader v-else class="mt-4 grey--text text--darken-1">Confirmados</v-subheader>
      <v-list three-line>
        <template v-for="(winner) in this.$store.state.winners">
          <v-list-item
              :key="winner.number"
          >
            <v-list-item-avatar>
              <v-img :src="winner.avatar"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-html="winner.fullName"></v-list-item-title>
              <v-list-item-subtitle v-if="showSensiveData" v-html="winner.hiddenEmail"></v-list-item-subtitle>
              <v-list-item-subtitle><h2>{{ winner.course }}</h2></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";

String.prototype.splice = function (idx, rem, str) {
  return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
};
export default {
  data: () => ({
    loading: false,
    showSensiveData: true
  }),
  created () {
  },
  computed: {},
  methods: {
    clearAllWinners () {
      this.clearWinners()
    },
    exportCSV () {
      const rows = this.$store.state.winners

      let csvContent = "data:text/csv;charset=utf-8,"
      csvContent += "nome, email, telefone, curso"
      csvContent += "\r\n"

      rows.forEach(function (r) {
        let row = `${ r.fullName },${ r.email },${ r.phone },${ r.course }`
        csvContent += row + "\r\n";
      })
      console.log(csvContent)
      var encodedUri = encodeURI(csvContent)
      console.log(encodedUri)
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      const today = new Date().toISOString().split('T')[0]
      link.setAttribute("download", today + "-ganhadores-tubarao-sorteador.csv");
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv".

    },
    ...mapActions(['clearWinners'])
  }
}
</script>

